import { Post } from 'lib/types';
import getConfig from 'next/config';
import { EmbedFallback } from './EmbedFallback';

interface Props {
  post: Post;
}

interface ConfigType {
  publicRuntimeConfig: Record<'GONDOLA_ENV', 'local' | 'staging' | 'production'>;
}

export const TwitchEmbed = ({ post }: Props) => {
  const { publicRuntimeConfig }: ConfigType = getConfig();

  if (!post.sourceId) {
    return <EmbedFallback post={post} />;
  }

  const envMapping = {
    local: 'localhost',
    staging: 'grooming.gondola.cc',
    production: 'gondola.cc',
  };
  const parent = envMapping[publicRuntimeConfig.GONDOLA_ENV] || 'gondola.cc';

  const sourceUrl = post.url.includes('/clips')
    ? `https://clips.twitch.tv/embed?clip=${post.sourceId}&parent=${parent}`
    : `https://player.twitch.tv/?video=${post.sourceId}&parent=${parent}`;

  return (
    <iframe
      title={post.account}
      src={sourceUrl}
      width="100%"
      height="100%"
      style={{ border: 'none', overflow: 'hidden' }}
      allowFullScreen
    />
  );
};
